import Cookies from 'js-cookie';
import { couponHandler } from '.';
import { getCookieValue } from '../commonUtils';
import { cartFillerSkus } from '../../components/CartOverlayContainer/Cart/Constants';
import { getWebUserType } from '../getWebUserType';

export const cartDataInitializer = (
  removeDefaultCoupon,
  query,
  freebieProductId = null, // TuesdaySale Freebie Product
) => {
  const couponData = couponHandler();

  return {
    inapp: 0,
    useGullackPoints: false,
    paymentmethod: 1, // For cart page it is always 1
    referrer: false, // For cart page it is always false
    // web_product_id: getUserIsLoggedIn() ? null : getCartItemsCookie(),
    web_user_id: Cookies.get('web_user_id_react'),
    save_later_id: null,
    useCouponCode: !!couponData,
    type: Cookies.get('offer_user_type'), // rach, chan, mon or joe from friends
    user_type: getWebUserType(),
    coupon: couponData,
    removeCouponCode: removeDefaultCoupon,
    freebieProductId: freebieProductId
      ? freebieProductId
      : Cookies.get('freeBieProductId')
        ? Cookies.get('freeBieProductId')
        : null,
    cart_filler_ids: cartFillerSkus.join(','),
  };
};

export const cartDataInitializerForSSR = (
  removeDefaultCoupon,
  query,
  cookiesString,
  freebieProductId = null,
) => {
  let couponData = couponHandlerRouter(query, cookiesString);
  let offer_user_type = getCookieValue(cookiesString, 'offer_user_type');

  return {
    inapp: 0,
    useGullackPoints: false,
    paymentmethod: 1, // For cart page it is always 1
    referrer: false, // For cart page it is always false
    // web_product_id: getWebProductIds(cookiesString),
    save_later_id: null,
    useCouponCode: !!couponData,
    type: offer_user_type, // rach, chan, mon or joe from friends
    user_type: getWebUserType(),
    coupon: couponData,
    removeCouponCode: removeDefaultCoupon,
    freebieProductId: freebieProductId
      ? freebieProductId
      : getFreebieProductId(cookiesString)
        ? getFreebieProductId(cookiesString)
        : null,
  };
};

function getWebProductIds(cookiesString) {
  let user_logged_in = getCookieValue(cookiesString, 'token');
  if (user_logged_in) {
    return null;
  }
  let cart_value = getCookieValue(cookiesString, 'cart_items');
  return cart_value;
}

function getFreebieProductId(cookiesString) {
  let freebieProductId = getCookieValue(cookiesString, 'freeBieProductId');
  if (freebieProductId) {
    return freebieProductId;
  }
}

function couponHandlerRouter(query, cookiesString) {
  const queryCoupon = query['coupon'];
  const cookieCoupon = getCookieValue(cookiesString, 'coupon_code');
  if (queryCoupon) {
    return queryCoupon;
  } else if (cookieCoupon) {
    return cookieCoupon;
  } else {
    return null;
  }
}
